
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pois/detail",
      function () {
        return require("private-next-pages/pois/detail/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pois/detail"])
      });
    }
  